import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'web_component_library/button';
import A11yContent from 'web_component_library/A11yContent';
import freedomTheme from 'web_component_library/theme/freedom';

const { colors } = freedomTheme;

export const DotButton = ({ onClick, isSelected }) => (
  <Button
    variant="none"
    onClick={onClick}
    borderRadius="50%"
    sx={{
      width: '1rem',
      height: '1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isSelected ? colors.accessibleOrange : colors.grey,
      padding: 0,
      transition: 'all 300ms',
      border: 'none',
      cursor: 'pointer',
    }}
  >
    <A11yContent>Go to slide</A11yContent>
  </Button>
);

DotButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export const useDotButton = emblaApi => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState([]);

  const onDotButtonClick = useCallback(
    index => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi],
  );

  const onInit = useCallback(api => {
    setScrollSnaps(api.scrollSnapList());
  }, []);

  const onSelect = useCallback(api => {
    setSelectedIndex(api.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onInit(emblaApi);
    onSelect(emblaApi);
    emblaApi
      .on('reInit', onInit)
      .on('reInit', onSelect)
      .on('select', onSelect);
  }, [emblaApi, onInit, onSelect]);

  return {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick,
  };
};
